import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { NotesService } from './notes.service';

export const firstNoteRedirectGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const notesService = inject(NotesService);
  const router = inject(Router);

  try {
    const notesObservable = await notesService.getAllNotes({ pageSize: 1, pageIndex: 0 }, true);
    const response = await firstValueFrom(notesObservable);

    let noteIdToRedirect: string;

    if (response && response.notes && response.notes.length > 0) {
      noteIdToRedirect = response.notes[0]._id;
    } else {
      const newNote = await notesService.createNewNote();
      noteIdToRedirect = newNote.id;
    }

    return router.createUrlTree(['/notes', noteIdToRedirect]);
  } catch (error) {
    return router.createUrlTree(['/home']);
  }
};
